import React from 'react'
import { Box, Heading, Text, Flex, Spacer, HStack, Button, ButtonProps } from '@chakra-ui/react'

interface ActionButton extends Omit<ButtonProps, 'children'> {
  label: string
  icon?: React.ReactElement
}

interface PageHeaderProps {
  title: string
  description?: string
  actions?: ActionButton[]
  children?: React.ReactNode
}

export default function PageHeader({
  title,
  description,
  actions = [],
  children,
}: PageHeaderProps) {
  return (
    <Flex mb={6} align="start" justify="space-between" gap={4}>
      <Box flex={1}>
        <Heading size="lg" mb={description ? 2 : 0} color="gray.800">
          {title}
        </Heading>
        {description && (
          <Text color="gray.600" fontSize="md">
            {description}
          </Text>
        )}
        {children}
      </Box>

      {actions.length > 0 && (
        <HStack spacing={3} flexShrink={0}>
          {actions.map((action, index) => {
            const { label, icon, ...buttonProps } = action
            return (
              <Button key={index} leftIcon={icon} colorScheme="blue" {...buttonProps}>
                {label}
              </Button>
            )
          })}
        </HStack>
      )}
    </Flex>
  )
}
